<template>
	<base-dialog variant="fullscreen" :lock-scroll="false" @close="$emit('close')">
		<div class="dialog-wrap">
			<div class="dialog-img-wrap">
				<svg-icon name="cross" class="dialog-close" @click.self="$emit('close')" :size="16" />
				<img :src="imageUrl" class="dialog-wrap-img" />
				<message-controls :image-url="imageUrl" :size-controls="32" />
			</div>
		</div>
	</base-dialog>
</template>

<script setup lang="ts">
import BaseDialog from '../base/BaseDialog.vue'
import MessageControls from '@/components/MessageControls.vue'
import SvgIcon from '@/components/SvgIcon.vue'

defineEmits<{
	close: []
}>()

defineProps({
	imageUrl: { type: String }
})
</script>

<style lang="scss" scoped>
.dialog {
	&-img-wrap {
		position: relative;
	}
	&-close {
		color: var(--text-inverse);
		transition: $transition-color;
		position: absolute;
		right: -24px;
		top: -16px;
		cursor: pointer;
		&:hover {
			color: var(--text-inverse);
		}
		&:active {
			color: var(--text-inverse);
		}
	}
	&-wrap {
		padding: 16px;
		width: calc(100% - 48px);
		height: calc(100svh - 96px);
		@include flex-column-center;
		&-img {
			max-width: 100%;
			max-height: calc(100svh - 96px);
			border-radius: var(--radius-lg);
			object-fit: contain;
		}
	}
}

:deep(.message-controls) {
	& svg {
		color: var(--text-inverse);
	}
	& .message-controls-control {
		opacity: 1;
	}
}
</style>
